module.exports = __webpack_public_path__ + "img/service4DE.325fd711.svg";